import React from "react";
import {Helmet} from "react-helmet-async";

const BASE = 'https://www.proteamyonetim.com';
const DEFAULT_IMAGE = `${BASE}/og-image.png`;

const SEO = ({title, description, path = '', image = DEFAULT_IMAGE, noindex = false}) => {
	const url = `${BASE}${path}`;
	return (
		<Helmet prioritizeSeoTags>
			<title>{title}</title>
			<meta name="description" content={description}/>
			<link rel="canonical" href={url}/>
			{noindex && <meta name="robots" content="noindex, nofollow"/>}

			<meta property="og:type" content="website"/>
			<meta property="og:locale" content="tr_TR"/>
			<meta property="og:site_name" content="Proteam Yönetim"/>
			<meta property="og:title" content={title}/>
			<meta property="og:description" content={description}/>
			<meta property="og:url" content={url}/>
			<meta property="og:image" content={image}/>

			<meta name="twitter:card" content="summary_large_image"/>
			<meta name="twitter:title" content={title}/>
			<meta name="twitter:description" content={description}/>
			<meta name="twitter:image" content={image}/>
		</Helmet>
	);
};

export default SEO;
